import { BackIcon, EditIconBlue, NavCloseIcon } from 'assets/icons';
import { FC, useState } from 'react';
import { JobStatus } from '../constant';
import { getJobStatusColor, getJobStatusText } from '../utils';
import { CustomButton, CustomTextArea } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { useEditJobStatusMutation } from '../api';
import { API_RESPONSES } from 'types/baseTypes';

interface EditStatusPanelDetailProps {
  status: JobStatus;
  onBackClick: () => void;
  onSave: (jobStatus: JobStatus) => void;
  jobId: string;
  teamId: number;
  isRootState?: boolean;
}

const EditStatusDetailPanel: FC<EditStatusPanelDetailProps> = ({
  status,
  onBackClick,
  onSave,
  jobId,
  teamId,
  isRootState = false
}) => {
  const [statusNote, setStatusNote] = useState('');
  const [editJobStatusMutation, editJobStatusState] = useEditJobStatusMutation();
  const { isLoading: isEditJobStatusLoading } = editJobStatusState;

  const onSaveClick = () => {
    editJobStatusMutation({
      status,
      note: statusNote.trim(),
      jobId,
      teamId
    }).then(response => {
      if ('data' in response && response.data.data.message === API_RESPONSES.SUCCESS) {
        onSave(status);
      }
    });
  };
  return (
    <div className="h-full w-96">
      <div className="flex items-center border-b border-secondaryBtn py-4">
        <div onClick={onBackClick} className="mx-4 cursor-pointer">
          {isRootState ? <NavCloseIcon id="job-details-panel-close" /> : <BackIcon id="job-details-panel-back-arrow" />}
        </div>
        <div className="text-17px font-semibold text-headingGray">Status</div>
      </div>
      <div className="my-6 px-4">
        <div className="mt-6">
          <div className="mb-2 text-sbase font-bold text-primaryText">Status</div>
          <div className="flex items-center justify-between rounded-md border border-borderGray p-4">
            <div className="flex items-center gap-x-2">
              <div className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: getJobStatusColor(status) }} />
              <div className="text-sbase" style={{ color: getJobStatusColor(status) }}>
                {getJobStatusText(status)}
              </div>
            </div>
            {!isRootState && (
              <EditIconBlue className="h-[18px] w-[18px] shrink-0 cursor-pointer" onClick={onBackClick} />
            )}
          </div>
        </div>
        <div className="mt-5">
          <div className="mb-2 text-sbase font-bold text-primaryText">Add note</div>
          <CustomTextArea
            id="edit-status-note"
            name="edit-status-note"
            className="h-[140px] max-h-[140px] rounded-md border border-borderGray bg-transparent font-medium 
                    text-accentText focus:outline-none"
            value={statusNote}
            onChange={setStatusNote}
          />
        </div>
      </div>
      <div className="flex w-full flex-col gap-y-4 p-4">
        <CustomButton
          id="edit-status-save-button"
          className="w-full"
          onClick={onSaveClick}
          isLoading={isEditJobStatusLoading}>
          Save
        </CustomButton>
        <CustomButton
          id="edit-status-cancel-button"
          className="w-full"
          onClick={onBackClick}
          type={ButtonType.SECONDARY}>
          Cancel
        </CustomButton>
      </div>
    </div>
  );
};

export default EditStatusDetailPanel;
